import React from "react";
import { connectRange } from "react-instantsearch/connectors";
import SliderContainer from "../SliderContainer";

class ConnectedSlider extends React.Component {
  constructor() {
    super();

    this.state = {
      lowerBound: 0,
      upperBound: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.canRefine) {
      this.setState({
        lowerBound: nextProps.currentRefinement.min,
        upperBound: nextProps.currentRefinement.max
      });
    }
  }

  onAfterChange = ([lowerBound, upperBound]) => {
    const { canRefine, currentRefinement, refine } = this.props;
    if (
      canRefine &&
      (lowerBound !== currentRefinement.min ||
        upperBound !== currentRefinement.max)
    ) {
      refine({
        min: lowerBound,
        max: upperBound
      });
    }
  };

  handleChange = ([lowerBound, upperBound]) => {
    this.setState({
      lowerBound,
      upperBound
    });
  };

  render() {
    const { canRefine, min, max, _label, _unit } = this.props;
    const { lowerBound, upperBound } = this.state;
    return (
      <SliderContainer
        label={_label}
        min={min}
        max={max}
        lowerBound={lowerBound}
        upperBound={upperBound}
        unit={_unit}
        onSliderChange={this.handleChange}
        onAfterChange={this.onAfterChange}
        disabled={!canRefine}
      />
    );
  }
}

export default connectRange(ConnectedSlider);



// WEBPACK FOOTER //
// ./src/ConnectedSlider/ConnectedSlider.js